import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const medios = {
  state: {},
  getters: {},
  mutations: {
    null() {

    }
  },
  actions: {

    requestMedios: ({
      commit
    }, data) => {

      console.log(data);

      return new Promise((resolve) => {
        axios.post(`/api/media`, data).then(response => {
          resolve(response.data);
          commit('null');
        });
      });
    }
   

  },
  modules: {}
}

export default medios;



// WEBPACK FOOTER //
// ./src/store/medios.js